import { GET_ACCOMODATION_POSSIBLE_CATEGORY_TYPES, GET_CATEGORY_TYPES, GET_COUNTRIES, GET_FEEDBACKS, GET_POSSIBLE_CATEGORY_TYPES, GET_POSSIBLE_CATEGORY_VALUES, GET_SERVICE_POINTS, SET_LOADING, SET_SIDEBAR, SHOW_SELECT } from '../types'

const ResourceReducer = (state, action) => {

    switch (action.type) {
       
        case GET_COUNTRIES:
            return {
                ...state,
                countries: action.payload,
                loading: false
            }
       
        case GET_SERVICE_POINTS:
            return {
                ...state,
                servicePoints: action.payload,
                loading: false
            }
        case GET_CATEGORY_TYPES:
            return {
                ...state,
                categoryTypes: action.payload,
                loading: false
            }
        case GET_ACCOMODATION_POSSIBLE_CATEGORY_TYPES:
            return {
                ...state,
                accomodationPossibleTypes: action.payload,
                loading: false
            }

        case GET_POSSIBLE_CATEGORY_TYPES:
            return {
                ...state,
                possibleTypes: action.payload,
                loading: false
            }
        case GET_POSSIBLE_CATEGORY_VALUES:
            return {
                ...state,
                possibleCategoryValues: action.payload,
                loading: false
            }
        case GET_FEEDBACKS:
            return {
                ...state,
                feedbacks: action.payload,
                loading: false
            }
        case SHOW_SELECT:
            return {
                ...state,
                showSelect: action.payload,
                loading: true
            }
        case SET_SIDEBAR:
            return {
                ...state,
                sidebar: action.payload,
                loading: true
            }
        case SET_LOADING:
            return {
                ...state,
                loading: true
            }

        default:
            return state
    }

}

export default ResourceReducer